import React from 'react'
import { shorten } from 'front-end-core/services/ShortenerService'
import url from 'front-end-core/core/url'
import { CURRENT_AWARENESS_ARTICLE } from 'constants/controllers'
import IconButtons from 'pages/currentawarenessarticle/IconButtons'
import { htmlText } from 'helpers/htmlText'
import cx from 'classnames'
import { setContentLinksTargetAttribute } from 'pages/dashboard/CaStories'
import { parseHtmlContent } from 'helpers/parseHtmlContent'
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
import HTMLEllipsis from 'react-lines-ellipsis/lib/html'
import Route from 'route-parser'
import { URL_THUMBOR } from 'constants/urls'
import Icon from 'components/shared/Icon'
import { UrlIdpRedirect } from 'helpers/redirects'
import { RequestFreeTrialButton } from 'components/ReusableButtons'
import { BackToHomeLink } from 'pages/currentawarenessarticle/Main'
import Grid from '@material-ui/core/Grid'
import { map } from 'rxjs/operators'

const ResponsiveHTMLEllipsis = responsiveHOC()(HTMLEllipsis)
const thumborRoute = new Route(URL_THUMBOR)

const Article = ({ title, content, publishDate, path, aol, id, isLogged, imageUrl }) => {
  const stateSource = shorten(url(CURRENT_AWARENESS_ARTICLE, { aol, id })).pipe(
    map(short => ({ short }))
  )

  return (
    <>
      <div className='bt-thick bt--light-sea-green-2'>
        <Title title={title} cxNames='f2' />
        <div className='flex justify-between items-center'>
          <PublicationDate publishDate={publishDate} />
          <IconButtons classNames='-bottom5' {...{ isLogged, aol, id, stateSource, title }} />
        </div>
        <Divider />
        {imageUrl && (
          <img src={thumborRoute.reverse({ url: imageUrl, size: '672x378' })} className='w-100 h-auto mt6' />
        )}
        <ArticleContent isLogged={isLogged} content={content} />
      </div>
      <div className='flex justify-between items-baseline mt4'>
        <BackToHomeLink />
        <IconButtons classNames='top6' {...{ isLogged, aol, id, stateSource, title }} />
      </div>
    </>
  )
}

const ArticleContent = ({ content, isLogged }) => (
  <div className='relative mt5 ca-homepage'>
    <Content content={content} isLogged={isLogged} />
    <SignUpOverlay isLogged={isLogged} />
  </div>
)

const Title = ({ title, cxNames }) => {
  const titleText = htmlText(title)

  return (
    <div className={cx('ca-article-headline-title b black fw8', cxNames)}>
      {titleText}
    </div>
  )
}
const PublicationDate = ({ publishDate }) => <p className='f6 mv0 cadet-blue'>{publishDate}</p>
const Divider = () => <div className='ba b--cadet-blue mt5' />

const Content = ({ isLogged, content }) => {
  if (!isLogged) {
    return (
      <ResponsiveHTMLEllipsis
        maxLine={2}
        ellipsis=''
        basedOn='words'
        unsafeHTML={content}
        className='black relative fade-out-overlay'
      />
    )
  }

  const contentEl = setContentLinksTargetAttribute(content, '_blank')

  return (
    <div className=''>
      {parseHtmlContent(contentEl.innerHTML)}
    </div>
  )
}

const MarketingItem = ({ text }) => (
  <div className='lh-copy f5 b pb7'>
    <Grid container direction='row' justify='flex-start'>
      <Grid item xs={1}>
        <Icon name='icon-checkbox-marked-circle' />
      </Grid>
      <Grid item xs={11} className='pl6'>
        {text}
      </Grid>
    </Grid>
  </div>
)

const marketingTextItems = [
  'High quality corporate precedents',
  'Updates on legal developments & horizon-scanning publications',
  'Public company information & analytics service',
  'Up-to-date legislation service'
]

const MarketingList = () => (
  <div className='article-page-icons bg-cadet-blue white tl pt8 pb6 ph11 ph8-t ph4-m'>
    <MarketingItem text={<div>{'Searchable comprehensive Q&A with '}<i>{'editors\' views'}</i>{' on difficult or unresolved points of law'}</div>} />
    {marketingTextItems.map((item, index) => <MarketingItem key={index} text={item} />)}
  </div>
)

const SignUpOverlay = ({ isLogged }) => !isLogged && (
  <div className='bg-white w-100 br1 shadow-8-04 tc z5 relative'>
    <div className='dib bg-cadet-blue w-100'>
      <div className='flex justify-center mv7'>
        <div className='pr3 f5 white'>Already have an account?</div>
        <a className='sign-in-link f5 b white no-underline hover-underline' href={UrlIdpRedirect()}>
          Sign in
        </a>
      </div>
    </div>
    <div className='ph8 ph7-t ph6-m mb7 relative'>
      <div className='dib f2 b black lh-headline mt8 mb7'>Sign up to get full access</div>
      <div className='dib f4 black lh-copy-variant mb6'>FromCounsel: Expert legal knowledge and analysis from barristers at Erskine Chambers and our team of PSLs from leading firms</div>
      <RequestFreeTrialButton analyticsLabel='Paywall (Article)' />
    </div>
    <MarketingList />
  </div>
)

export default Article
